<template>
	<div class="OfferDetail" :class="{ 'is-mobile': isMobile }">
		<common-body aside="4">
			<div slot="commonMain" class="quotation_box" v-loading.lock="loadingStatus">
				<div v-if="detail">
					<el-row type="flex" align="middle" justify="space-between" class="quotation_header">
						<el-row type="flex" align="middle" class="location_box">
							<div class="location_icon">
								<i class="el-icon-s-promotion"></i>
							</div>
							<el-row type="flex" align="middle" class="location_text">
								<div v-if="!isMobile">当前位置：</div>
								<el-button @click="goBack" type="text">我的报价</el-button>
								<div class="location_xie">/</div>
								<div>查看详情</div>
							</el-row>
						</el-row>
						<el-row type="flex" align="middle" class="header_r">
							<div
								v-if="canOpenColl"
								@click="openCollOrder"
								class="header_btn header_btn3">协同订单</div>
							<div @click="printQuotation" class="header_btn header_btn1">报价预览</div>
						</el-row>
					</el-row>
					<el-form label-position="right" :model="detail" class="quotation_form">
						<div class="detail_info_section">
							<el-tabs v-model="infoTab" type="card" class="detail_info_tabs">
								<el-tab-pane label="报价清单" name="goods">
									<div class="detail_goods_panel">
						<el-row type="flex" justify="space-between" class="quotation_info quotation_info--view">
							<div class="quotation_info_col">
								<div class="info-view-item">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('单号')" :key="'a'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value">
										{{ displayText(detail.order_number) }}
										<div v-if="detail.sample_deduct_text" class="sample-deduct-tag">{{ detail.sample_deduct_text }}</div>
									</div>
								</div>
								<div class="info-view-item info-view-item--address">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('收货地址')" :key="'b'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value info-view-value--multiline">{{ displayText(detail.receiving_address) }}</div>
								</div>
							</div>
							<div class="quotation_info_col">
								<div class="info-view-item">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('客户名称')" :key="'c'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value">{{ displayText(detail.customer_id) }}</div>
								</div>
								<div class="info-view-item">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('联系人')" :key="'d'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value">{{ displayText(detail.contacts) }}</div>
								</div>
								<div class="info-view-item">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('联系电话')" :key="'e'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value">{{ displayText(detail.contacts_phone) }}</div>
								</div>
							</div>
							<div class="quotation_info_col">
								<div class="info-view-item">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('报价日期')" :key="'f'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value">{{ displayText(detail.createTime) }}</div>
								</div>
								<div class="info-view-item">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('运输方式')" :key="'g'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value">{{ displayText(detail.delivery_text) }}</div>
								</div>
								<div class="info-view-item">
									<div class="info-view-label">
										<span class="info-view-label__text">
											<i v-for="(ch, i) in labelChars('发票类型')" :key="'h'+i">{{ ch }}</i>
										</span>
									</div>
									<div class="info-view-value">{{ displayText(detail.invoice_text) }}</div>
								</div>
							</div>
						</el-row>
						<p v-if="isMobile" class="od-table-hint">清单可左右滑动查看</p>
						<div class="od-table-scroll">
						<el-table ref="offerDetailTable" border stripe class="printTable" :row-class-name="detailTableRowClassName" :data="detailTableRows" style="width: 100%" cell-class-name="good_text" header-cell-class-name="good_header">
							<el-table-column :resizable="resizeable" align="center" min-width="3%" label="序号">
								<template slot-scope="scope">
									<div>{{scope.$index+1}}</div>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="10%" label="名称">
								<template slot-scope="scope">
									<template v-if="isExtraTableRow(scope.row)">
										<div class="good_name extra-cell-name">{{ scope.row.name }}</div>
									</template>
									<el-popover
										v-else
										placement="top"
										trigger="hover"
										:open-delay="2000"
										popper-class="offer-good-popover">
										<div class="good_reference">
											<img :src="scope.row.sku_image_text" />
										</div>
										<div slot="reference" class="good_name">{{ cartDisplayName(scope.row) }}</div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column v-if="detail.category!=13&&detail.category!=19&&detail.category!=29&&detail.category!=30&&detail.category!=31&&detail.category!=40&&detail.category!=43&&detail.category!=45" :resizable="resizeable" align="center" min-width="12%" label="尺寸(mm)">
								<template slot-scope="scope">
									<div class="good_size">
										<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
										<div v-else-if="scope.row.goods_valuation==1">-</div>
										<div v-else>{{scope.row.size_text}}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="12%" label="规格参数">
								<template slot-scope="scope">
									<div class="good_size">
										<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
										<span v-else>{{ scope.row.parameter_text }}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column v-if="detail.category==20||detail.category==25||detail.category==26||detail.category==27||detail.category==28||detail.category==32||detail.category==33||detail.category==44" :resizable="resizeable" align="center" min-width="4%" label="面积(㎡)">
								<template slot-scope="scope">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-dash">-</span>
									<span v-else>{{ scope.row.goods_areas }}</span>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="4%" label="数量">
								<template slot-scope="scope">
									<span>{{ scope.row.goods_num }}</span>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="4%" label="单位">
								<template slot-scope="scope">
									<span v-if="isExtraTableRow(scope.row)" class="extra-cell-unit">{{ scope.row.goods_unit }}</span>
									<span v-else>{{ scope.row.goods_unit }}</span>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="4%" label="单价">
								<template slot-scope="scope">
									<span v-if="isExtraTableRow(scope.row)" class="amount extra-cell-amount">{{ formatMoney(scope.row.singleton) }}</span>
									<span v-else>{{ formatMoney(scope.row.singleton) }}</span>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="4%" label="金额" class-name="is-amount">
								<template slot-scope="scope">
									<div v-if="isExtraTableRow(scope.row)" class="amount extra-cell-amount">{{ formatMoney(scope.row.amount) }}</div>
									<div v-else>{{ formatAmountBySingleton(scope.row) }}</div>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="4%" label="参考图">
								<template slot-scope="scope">
									<div v-if="!isExtraTableRow(scope.row)" class="good_size">
										<div @click="showReference(scope.row)" class="good_icon">
											<i v-if="scope.row.reference_image&&scope.row.reference_image!=''" class="el-icon-picture-outline"></i>
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="10%" label="备注" class-name="print-col-remark" header-class-name="print-col-remark">
								<template slot-scope="scope">
									<div class="good_remark_text" :class="{ 'extra-cell-remark': isExtraTableRow(scope.row) }">{{ scope.row.remarks == '' ? '无' : scope.row.remarks }}</div>
								</template>
							</el-table-column>
						</el-table>
						</div>
						<div class="goods_footer">
							<el-row type="flex" align="middle" class="goods_footer_item goods_footer_item--amount">
								<div class="goods_footer_amount_block">
									<el-row type="flex" align="middle" class="goods_footer_amount_line">
										<div class="goods_footer_text goods_footer_text--strong">小计：<span class="amount">¥</span></div>
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											:value="footerSubtotalText"
										></el-input>
									</el-row>
								</div>
								<div
									class="goods_footer_amount_spacer"
									aria-hidden="true"
									:style="{ flex: '0 0 ' + footerAmountSpacerPx + 'px', width: footerAmountSpacerPx + 'px', maxWidth: footerAmountSpacerPx + 'px' }"
								></div>
							</el-row>
							<el-row type="flex" align="middle" class="goods_footer_item goods_footer_item--amount">
								<div class="goods_footer_text goods_footer_maker">制单人：{{detail.user_name}}</div>
								<div class="goods_footer_amount_block goods_footer_amount_block--inline">
									<el-row type="flex" align="middle" class="goods_footer_amount_line goods_footer_amount_line--pair">
										<div class="goods_footer_text goods_footer_text--strong">折扣让利：<span class="amount">-¥</span></div>
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											:value="footerConcessionAbsText"
										></el-input>
										<div class="goods_footer_text goods_footer_text--strong goods_footer_text--pair-gap">合计：<span class="amount">¥</span></div>
										<el-input
											class="goods_footer_input goods_footer_price goods_footer_price--tight amount"
											:readonly="readonly"
											:value="footerTotalText"
										></el-input>
									</el-row>
								</div>
								<div
									class="goods_footer_amount_spacer"
									aria-hidden="true"
									:style="{ flex: '0 0 ' + footerAmountSpacerPx + 'px', width: footerAmountSpacerPx + 'px', maxWidth: footerAmountSpacerPx + 'px' }"
								></div>
							</el-row>
							<el-row type="flex" align="top" class="goods_footer_item goods_footer_item--remark">
								<div class="goods_footer_text goods_footer_text--remark">订单备注</div>
								<div
									class="goods_footer_remark_text"
									:class="{ 'goods_footer_remark_text--empty': !detail.remarks }"
								>{{ detail.remarks || '暂无备注' }}</div>
							</el-row>
						</div>
						<el-form-item>
							<el-row class="quotation_btns" type="flex" align="middle" justify="center">
								<div v-if="detail.purchase_status==0&&detail.place_order_status==1&&detail.status==1" class="quotation_btn quotation_btn1" @click="editOffer">编辑单据</div>
								<!-- <div class="quotation_btn quotation_btn1" @click="editOffer">编辑单据</div> -->
								<div class="quotation_btn quotation_btn2" @click="delOffer">删除单据</div>
							</el-row>
						</el-form-item>
									</div>
								</el-tab-pane>
								<el-tab-pane label="订单信息" name="order">
									<div class="detail_order_panel">
						<el-row type="flex" align="middle" justify="space-between" class="quotation_title">
							<div class="title_text">订单状态</div>
						</el-row>
						<el-form ref="statusForm" label-position="left" label-suffix="" :model="statusForm" class="order_status_form">
							<div class="order-status-row">
								<div class="order-status-label">生产状态：</div>
								<div class="order-status-content">
									<el-radio-group
										v-model="statusForm.place_order_status"
										class="order-status-group"
										@change="onPlaceOrderStatusChange">
										<div class="order-status-option">
											<el-radio label="1">待安排</el-radio>
										</div>
										<div class="order-status-option">
											<el-radio label="2">安排生产</el-radio>
										</div>
									</el-radio-group>
								</div>
							</div>
							<div class="order-status-row">
								<div class="order-status-label">付款状态：</div>
								<div class="order-status-content">
									<el-radio-group
										v-model="statusForm.pay_status"
										class="order-status-group"
										@change="onPayStatusChange">
										<div class="order-status-option">
											<el-radio label="1">未付款</el-radio>
										</div>
										<div class="order-status-option">
											<el-radio label="2">已付款</el-radio>
										</div>
										<div class="order-status-option">
											<el-radio label="3">售后补单</el-radio>
										</div>
									</el-radio-group>
								</div>
							</div>
							<div class="order-status-row order-status-row--remark">
								<div class="order-status-label">收款备注：</div>
								<div class="order-status-content order-status-content--remark">
									<el-input
										type="textarea"
										:rows="3"
										:clearable="clearable"
										resize="none"
										maxlength="500"
										show-word-limit
										placeholder="请输入收款备注"
										v-model="statusForm.received_note"></el-input>
									<el-button
										type="primary"
										size="small"
										:loading="statusSaving"
										@click="saveReceivedNote">保存收款备注</el-button>
								</div>
							</div>
							<div v-if="detail.sample_deduct_text" class="order-status-row order-status-row--amount">
								<div class="order-status-label">出样抵扣：</div>
								<div class="order-status-content order-status-content--amount">
									<div class="sample-deduct-tag">{{ detail.sample_deduct_text }}</div>
								</div>
							</div>
							<div class="order-status-row order-status-row--amount">
								<div class="order-status-label">应付金额：</div>
								<div class="order-status-content order-status-content--amount">
									<div class="order-status-amount-text amount">{{ formatMoney(footerTotalText) }}</div>
								</div>
							</div>
							<!-- 已付款 / 售后补单：实收款行内输入/保存；售后补单实收款可为 0 -->
							<template v-if="isPayReceivedStatus(statusForm.pay_status)">
								<div class="order-status-row order-status-row--amount">
									<div class="order-status-label">实收款：</div>
									<div class="order-status-content order-status-content--amount">
										<template v-if="isReceivedEditing">
											<el-input
												class="order-status-amount"
												:placeholder="isAfterSalesPayStatus(statusForm.pay_status) ? '可填 0' : '请输入实收款金额'"
												v-model="statusForm.received_amount"></el-input>
											<el-button
												type="primary"
												size="small"
												:loading="statusSaving"
												@click="savePaidStatus">保存实收款</el-button>
										</template>
										<template v-else>
											<div class="order-status-amount-text amount">{{ formatMoney(statusForm.received_amount) }}</div>
											<el-button
												type="primary"
												plain
												size="small"
												@click="startReceivedEdit">修改</el-button>
										</template>
									</div>
								</div>
								<div class="order-status-row order-status-row--files">
									<div class="order-status-label">附件：</div>
									<div class="order-status-content order-status-content--files">
										<imageUpload
											v-model="statusForm.received_files"
											:limit="uploadLimit"
											:multiple="true"
											:fileType="fileType"
											compact
											:cell-size="72" />
									</div>
								</div>
							</template>
						</el-form>
									</div>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-form>
					<!-- 参考图 -->
					<el-dialog class="reference_dialog" :visible.sync="referenceStatus" top="5vh" :append-to-body="true">
						<div class="reference_title" slot="title">参考图</div>
						<el-row type="flex" align="middle" class="reference_box">
							<div class="reference_item" v-for="(item,index) in reference.reference_images" :key="index">
								<el-row type="flex" align="middle" justify="center" class="reference_img">
									<el-image :src="item">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
											<div class="reference_tip">CAD文件</div>
										</div>
									</el-image>
								</el-row>
								<el-row type="flex" align="middle" justify="center" class="reference_btn">
									<a :href="item" target="_blank">
										<el-button type="info" size="small">下载</el-button>
									</a>
								</el-row>
							</div>
						</el-row>
					</el-dialog>
					<!-- 实收款附件预览 -->
					<el-dialog :visible.sync="receivedPreviewVisible" title="预览" width="800px" append-to-body>
						<img v-if="receivedPreviewUrl" :src="receivedPreviewUrl" style="display:block;max-width:100%;margin:0 auto" />
					</el-dialog>
					<!-- 协同订单 -->
					<el-dialog class="coll_dialog" :visible.sync="collStatus" top="10vh" :append-to-body="true">
						<div class="coll_title" slot="title">协同订单</div>
						<el-form label-width="100px" label-position="right">
							<div class="coll_box">
								<el-form-item label="单号">
									<input class="coll_input" readonly :value="detail.order_number" />
								</el-form-item>
								<el-form-item label="协同链接">
									<input class="coll_input coll_input--link" readonly :value="collUrl" />
								</el-form-item>
								<el-form-item label="有效时间">
									<div class="coll_input">
										<el-date-picker
											@change="setCollDate"
											v-model="collDate"
											format="yyyy年MM月dd日HH时mm分"
											value-format="timestamp"
											:editable="false"
											:clearable="false"
											type="datetime"
											placeholder="选择日期时间" />
									</div>
								</el-form-item>
								<el-form-item label="">
									<el-row type="flex" class="coll_actions">
										<el-button @click="copyColl" type="primary" size="small">复制链接</el-button>
										<el-button @click="addColl" type="success" size="small">延长一天</el-button>
										<el-button @click="closeColl" type="danger" size="small" plain>关闭协同</el-button>
									</el-row>
								</el-form-item>
							</div>
						</el-form>
					</el-dialog>
				</div>
			</div>
		</common-body>
	</div>
</template>

<script>
	import {
		accMul,
		accDiv,
		accAdd,
		accSub,
		getT
	} from "../assets/js/public.js"
	import { applyMobileViewport } from '@/utils/isMobile'
	import { cartDisplayName } from '@/utils/cart-display'
	import ImageUpload from '@/components/ImageUpload'
	import { mergeReadonlyTableRows, isExtraTableRow } from '@/utils/extra-fees'
	export default {
		name: 'OfferDetail',
		components: {
			ImageUpload,
		},
		data() {
			let that = this
			return {
				baseUrl: process.env.CDN_BASE || "http://127.0.0.1:19000/baojia-system",
				offer_id: "",
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				readonly: !0,
				loadingStatus: !0,
				infoTab: 'goods',
				detail: null,
				statusForm: {
					id: '',
					place_order_status: '1',
					pay_status: '1',
					received_amount: '',
					received_files: '',
					received_note: '',
					remarks: ''
				},
				statusSaving: !1,
				statusFormSyncing: !1,
				/** 实收款编辑态：首次填写或点「修改」后为 true；保存成功后为 false */
				receivedEditing: !1,
				clearable: !0,
				border: !0,
				resizeable: !1,
				uploadLimit: 6,
				fileType: ['jpg', 'jpeg', 'png', 'webp'],
				receivedPreviewVisible: !1,
				receivedPreviewUrl: '',
				purchaseForm: {
					user_id: '',
					order_id: '',
					service_name: '',
					purchase_status: '',
					purchase_status_text: '',
					purchase: ''
				},
				purchaseStatus: !1,
				purchase: [],
				purchaseIndex: '',
				reference: [],
				referenceStatus: !1,
				/** footer 右侧占位：使小计/合计与表格「金额」列右缘对齐 */
				footerAmountSpacerPx: 0,
				collStatus: !1,
				collUrl: '',
				collDate: 0,
				collLoading: !1,
				isMobile: false,
			}
		},
		beforeRouteLeave(to,from,next) {
			if(to.name === 'Offer'){
				to.meta.keepAlive = !0
			}
			next()
		},
		created() {
			this.updateIsMobile()
			this.reload();
		},
		mounted() {
			this.updateIsMobile()
			window.addEventListener('resize', this.onOfferDetailResize)
			window.addEventListener('orientationchange', this.onOfferDetailResize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.onOfferDetailResize)
			window.removeEventListener('orientationchange', this.onOfferDetailResize)
		},
		beforeUpdate() {
			this.$nextTick(() => {
				if (this.$refs.offerDetailTable) {
					this.$refs.offerDetailTable.doLayout()
				}
				this.syncFooterAmountAlign()
			})
		},
		computed: {
			/** 待安排生产时才可开协同 */
			canOpenColl() {
				if (!this.detail) return false
				return String(this.detail.place_order_status ?? '1') !== '2'
			},
			/** 已持久化为需展示实收款区块的状态（已付款有金额，或售后补单已保存） */
			isReceivedPaidView() {
				if (!this.detail) return false
				const ps = String(this.detail.pay_status ?? '1')
				if (ps === '2') {
					const n = Number(this.detail.received_amount)
					return Number.isFinite(n) && n > 0
				}
				if (ps === '3') {
					const n = Number(this.detail.received_amount)
					return Number.isFinite(n) && n >= 0
				}
				return false
			},
			/** 编辑中：未落库，或已落库后点了「修改」 */
			isReceivedEditing() {
				return this.receivedEditing || !this.isReceivedPaidView
			},
			receivedFileList() {
				const raw = (this.detail && this.detail.received_files) || this.statusForm.received_files || ''
				return this.parseReceivedFiles(raw)
			},
			/** 小计 / 折扣让利 / 合计（与报价页口径一致，只读展示） */
			footerAmountView() {
				if (!this.detail) {
					return { totalAll: '', extraSum: '0.00', concessionAbs: '0.00', total: '' }
				}
				let subtotal = 0
				let dealSum = 0
				;(this.detail.goodslist || []).forEach((row) => {
					const unit = Number(row && row.singleton)
					const num = Number(row && row.goods_num)
					if (Number.isFinite(unit) && Number.isFinite(num) && num > 0) {
						subtotal = accAdd(subtotal, Number(accMul(unit, num).toFixed(2)))
					}
					const dealUnit = Number(row && row.discount_price != null && row.discount_price !== '' ? row.discount_price : row.singleton)
					if (Number.isFinite(dealUnit) && Number.isFinite(num) && num > 0) {
						dealSum = accAdd(dealSum, Number(accMul(dealUnit, num).toFixed(2)))
					}
				})
				const primary = Number(this.detail.total_primary)
				if (Number.isFinite(primary) && primary > 0) subtotal = primary
				const extraSum = Number(this.detail.extra_fees_sum != null ? this.detail.extra_fees_sum : 0)
					|| Number((this.detail.extra_fees || []).reduce(function(s, row) {
						return accAdd(s, Number(row.amount) || 0)
					}, 0))
				const concessionAbs = Math.abs(Number(accSub(dealSum, subtotal)) || 0)
				const totalNum = Number(this.detail.total)
				const total = Number.isFinite(totalNum) ? totalNum : accAdd(accAdd(subtotal, accSub(dealSum, subtotal)), extraSum)
				return {
					totalAll: Number(accAdd(subtotal, extraSum)).toFixed(2),
					extraSum: Number(extraSum).toFixed(2),
					concessionAbs: Number(concessionAbs).toFixed(2),
					total: Number(total).toFixed(2),
				}
			},
			footerSubtotalText() {
				return this.footerAmountView.totalAll
			},
			footerConcessionAbsText() {
				return this.footerAmountView.concessionAbs
			},
			footerTotalText() {
				return this.footerAmountView.total
			},
			detailTableRows() {
				if (!this.detail) return []
				return mergeReadonlyTableRows(this.detail.goodslist, this.detail.extra_fees, { includeExtras: true })
			},
		},
		watch: {
			/** 已付款落库后附件仍可操作，变更后自动保存 */
			'statusForm.received_files'(val) {
				if (this.statusFormSyncing || this.statusSaving || this.receivedEditing) return
				if (!this.isReceivedPaidView) return
				if (String(val || '') === String((this.detail && this.detail.received_files) || '')) return
				this.savePaidStatus()
			}
		},
		methods: {
			cartDisplayName,
			isExtraTableRow,
			updateIsMobile() {
				this.isMobile = applyMobileViewport()
			},
			onOfferDetailResize() {
				this.updateIsMobile()
				this.syncFooterAmountAlign()
			},
			detailTableRowClassName({ row }) {
				return isExtraTableRow(row) ? 'quotation-row--extra' : ''
			},
			/** 按表格「金额」列右缘实测 footer 占位，使小计/合计右对齐金额列 */
			syncFooterAmountAlign() {
				if (this.isMobile) {
					this.footerAmountSpacerPx = 0
					return
				}
				const table = this.$refs.offerDetailTable
				if (!table || !table.$el) return
				const headerWrapper = table.$el.querySelector('.el-table__header-wrapper') || table.$el
				const amountThs = headerWrapper.querySelectorAll('th.is-amount')
				if (!amountThs.length) return
				const amountTh = amountThs[amountThs.length - 1]
				const tableRect = headerWrapper.getBoundingClientRect()
				const amountThRect = amountTh.getBoundingClientRect()
				const spacer = Math.max(0, Math.round(tableRect.right - amountThRect.right))
				if (spacer !== this.footerAmountSpacerPx) {
					this.footerAmountSpacerPx = spacer
				}
			},
			displayText(val) {
				return val !== undefined && val !== null && val !== '' ? val : '—'
			},
			labelChars(text) {
				return Array.from(String(text || ''))
			},
			formatMoney(val) {
				if (val === undefined || val === null || val === '') return ''
				let text = String(val).trim()
				if (!text) return ''
				if (text.indexOf('¥') === 0 || text.indexOf('￥') === 0) text = text.slice(1).trim()
				const num = Number(text)
				if (!Number.isFinite(num)) return '¥ ' + text
				return '¥ ' + num.toFixed(2)
			},
			/** 金额列：按单价（singleton）× 数量，不按折扣价 */
			formatAmountBySingleton(row) {
				if (!row) return ''
				const unit = Number(row.singleton)
				const num = Number(row.goods_num)
				if (!Number.isFinite(unit) || !Number.isFinite(num)) return this.formatMoney(row.singleton)
				return this.formatMoney(accMul(unit, num))
			},
			resolveFileUrl(path) {
				if (!path) return ''
				if (/^https?:\/\//i.test(path)) return path
				const base = String(this.baseUrl || '').replace(/\/$/, '')
				return base + (String(path).startsWith('/') ? path : '/' + path)
			},
			parseReceivedFiles(value) {
				if (!value) return []
				const list = Array.isArray(value) ? value : String(value).split(',')
				const imageExt = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp']
				return list.map((item) => {
					const path = String(item || '').trim()
					if (!path) return null
					const ext = path.split('.').pop().toLowerCase()
					return {
						path,
						url: this.resolveFileUrl(path),
						isImage: imageExt.indexOf(ext) > -1
					}
				}).filter(Boolean)
			},
			previewReceivedFile(file) {
				if (!file || !file.url) return
				this.receivedPreviewUrl = file.url
				this.receivedPreviewVisible = !0
			},
			isPayReceivedStatus(status) {
				const ps = String(status ?? '')
				return ps === '2' || ps === '3'
			},
			isAfterSalesPayStatus(status) {
				return String(status ?? '') === '3'
			},
			normalizePayStatus(status) {
				const ps = String(status ?? '1')
				return ps === '2' || ps === '3' ? ps : '1'
			},
			payStatusLabel(status) {
				const ps = this.normalizePayStatus(status)
				if (ps === '2') return '已付款'
				if (ps === '3') return '售后补单'
				return '未付款'
			},
			syncStatusForm(detail) {
				this.statusFormSyncing = !0
				this.statusForm.id = detail.id || this.offer_id
				this.statusForm.place_order_status = String(detail.place_order_status ?? '1') === '2' ? '2' : '1'
				this.statusForm.pay_status = this.normalizePayStatus(detail.pay_status)
				const received = Number(detail.received_amount)
				const allowZero = this.isAfterSalesPayStatus(this.statusForm.pay_status)
				if (Number.isFinite(received) && (allowZero ? received >= 0 : received > 0)) {
					this.statusForm.received_amount = received.toFixed(2)
				} else {
					this.statusForm.received_amount = ''
				}
				this.statusForm.received_files = detail.received_files || ''
				this.statusForm.received_note = detail.received_note || ''
				this.statusForm.remarks = detail.remarks || ''
				// 已落库则默认展示态；未落库保持编辑
				const paid = this.isPayReceivedStatus(detail.pay_status)
					&& Number.isFinite(received)
					&& (this.isAfterSalesPayStatus(detail.pay_status) ? received >= 0 : received > 0)
				this.receivedEditing = !paid
				this.$nextTick(() => {
					this.statusFormSyncing = !1
				})
			},
			startReceivedEdit() {
				this.receivedEditing = !0
			},
			normalizeReceivedAmount(val, options) {
				const allowZero = !!(options && options.allowZero)
				const raw = String(val == null ? '' : val).replace(/[¥￥,\s]/g, '').trim()
				if (raw === '' && allowZero) return '0.00'
				const n = Number(raw)
				if (!Number.isFinite(n)) return ''
				if (allowZero ? n < 0 : n <= 0) return ''
				return n.toFixed(2)
			},
			isStatusFormDirty() {
				if (!this.detail) return !1
				const allowZero = this.isAfterSalesPayStatus(this.statusForm.pay_status)
					|| this.isAfterSalesPayStatus(this.detail.pay_status)
				const prevReceived = this.normalizeReceivedAmount(this.detail.received_amount, { allowZero }) || ''
				const nextReceived = this.normalizeReceivedAmount(this.statusForm.received_amount, { allowZero }) || ''
				return String(this.statusForm.place_order_status) !== String(this.detail.place_order_status ?? '1')
					|| String(this.statusForm.pay_status) !== String(this.detail.pay_status ?? '1')
					|| String(this.statusForm.remarks || '') !== String(this.detail.remarks || '')
					|| prevReceived !== nextReceived
					|| String(this.statusForm.received_files || '') !== String(this.detail.received_files || '')
					|| String(this.statusForm.received_note || '') !== String(this.detail.received_note || '')
			},
			applyStatusToDetail() {
				if (!this.detail) return
				this.detail.place_order_status = this.statusForm.place_order_status
				this.detail.place_order_status_text = this.statusForm.place_order_status === '2' ? '安排生产' : '待安排'
				this.detail.pay_status = this.statusForm.pay_status
				this.detail.pay_status_text = this.payStatusLabel(this.statusForm.pay_status)
				const allowZero = this.isAfterSalesPayStatus(this.statusForm.pay_status)
				this.detail.received_amount = this.isPayReceivedStatus(this.statusForm.pay_status)
					? (this.normalizeReceivedAmount(this.statusForm.received_amount, { allowZero }) || (allowZero ? '0.00' : 0))
					: 0
				this.detail.received_files = this.isPayReceivedStatus(this.statusForm.pay_status)
					? (this.statusForm.received_files || '')
					: ''
				this.detail.received_note = this.statusForm.received_note || ''
			},
			reload() {
				let that = this
				that.offer_id = that.$route.query.id, that.purchaseForm.order_id = that.$route.query.id, that.getDetail(), that.getPurchase()
			},
			getPurchase(){
				let that = this
				that.$fetch('addons/hlm/api.User/getServiceList').then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.purchase = res.data
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getDetail() {
				let that = this
				that.$fetch('addons/hlm/api.Order/getOderDetails', {
					id: that.offer_id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let detail = res.data
						detail.createTime = getT(detail.offertime*1000),detail.sendTime = getT(detail.sendtime*1000)
						that.syncStatusForm(detail)
						that.detail = detail, that.loadingStatus = !1
						that.$nextTick(function() {
							that.syncFooterAmountAlign()
						})
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			delOffer() {
				let that = this
				that.$confirm('确定删除该单据吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$fetch('addons/hlm/api.order/del', {
						id: that.offer_id
					}).then(function(res) {
						console.log(res)
						if (res.code == 1) {
							that.detailStatus = !1, that.$message({
								message: '删除成功',
								type: 'success',
								duration: 1500,
								center: !0,
								onClose() {
									that.$router.goBack()
								}
							})
						}
					}).catch(function(error) {
						console.log(error)
					})
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			saveOrderStatus(options) {
				let that = this
				const opts = options || {}
				const force = !!opts.force
				const silent = !!opts.silent
				if (that.statusSaving || that.statusFormSyncing || !that.detail) return
				if (!force && !that.isStatusFormDirty()) return
				const payStatus = that.normalizePayStatus(that.statusForm.pay_status)
				if (that.isPayReceivedStatus(payStatus)) {
					const allowZero = that.isAfterSalesPayStatus(payStatus)
					const amount = that.normalizeReceivedAmount(that.statusForm.received_amount, { allowZero })
					if (amount === '') {
						that.$message({
							message: allowZero ? '请填写实收款金额（可为 0）' : '请填写实收款金额',
							type: 'warning',
							duration: 2000,
							center: !0
						})
						return
					}
					that.statusForm.received_amount = amount
				}
				that.statusSaving = !0
				that.$fetch('addons/hlm/api.Order/updataStatus', {
					id: that.statusForm.id || that.offer_id,
					place_order_status: that.statusForm.place_order_status,
					pay_status: payStatus,
					received_amount: that.isPayReceivedStatus(payStatus)
						? that.statusForm.received_amount
						: 0,
					received_files: that.isPayReceivedStatus(payStatus)
						? (that.statusForm.received_files || '')
						: '',
					received_note: that.statusForm.received_note || '',
					remarks: that.detail.remarks || ''
				}).then(function(res) {
					if (res.code == 1) {
						if (res.data) {
							that.$set(that.detail, 'sample_deduct_amount', res.data.sample_deduct_amount || 0)
							that.$set(that.detail, 'sample_deduct_ratio', res.data.sample_deduct_ratio || 0)
							that.$set(that.detail, 'sample_deduct_text', res.data.sample_deduct_text || '')
							if (res.data.received_amount != null && that.isPayReceivedStatus(payStatus)) {
								that.statusForm.received_amount = Number(res.data.received_amount).toFixed(2)
							}
						}
						that.applyStatusToDetail()
						if (typeof opts.onSuccess === 'function') opts.onSuccess()
						if (!silent) {
							that.$message({
								message: '保存成功',
								type: 'success',
								duration: 1500,
								center: !0
							})
						}
					} else {
						that.syncStatusForm(that.detail)
						that.$message({
							message: (res && res.msg) || '保存失败',
							type: 'warning',
							duration: 2000,
							center: !0
						})
					}
					that.statusSaving = !1
				}).catch(function(error) {
					console.log(error)
					that.syncStatusForm(that.detail)
					that.statusSaving = !1
				})
			},
			saveReceivedNote() {
				this.saveOrderStatus({ force: !0 })
			},
			/** 已付款区块：填写金额与附件后主动保存 */
			savePaidStatus() {
				let that = this
				that.saveOrderStatus({ force: !0, onSuccess: function() {
					that.receivedEditing = !1
				}})
			},
			confirmStatusChange(message, onCancel) {
				let that = this
				that.$confirm(message, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function() {
					that.saveOrderStatus({ force: !0 })
				}).catch(function() {
					if (typeof onCancel === 'function') onCancel()
				})
			},
			onPlaceOrderStatusChange(val) {
				let that = this
				if (that.statusFormSyncing || !that.detail) return
				const prev = String(that.detail.place_order_status ?? '1') === '2' ? '2' : '1'
				if (String(val) === prev) return
				const label = String(val) === '2' ? '安排生产' : '待安排'
				that.confirmStatusChange('确定将生产状态改为「' + label + '」吗？', function() {
					that.statusForm.place_order_status = prev
				})
			},
			onPayStatusChange(val) {
				let that = this
				if (that.statusFormSyncing || !that.detail) return
				const prev = that.normalizePayStatus(that.detail.pay_status)
				const next = that.normalizePayStatus(val)
				if (next === prev) return
				if (next === '2' || next === '3') {
					const tip = next === '3'
						? '确定将付款状态改为「售后补单」吗？实收款可填 0，填写后请保存。'
						: '确定将付款状态改为「已付款」吗？请填写实收款后保存。'
					that.$confirm(tip, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(function() {
						that.statusForm.pay_status = next
						that.receivedEditing = !0
						const allowZero = next === '3'
						if (!that.normalizeReceivedAmount(that.statusForm.received_amount, { allowZero })) {
							that.statusForm.received_amount = allowZero ? '0.00' : ''
						}
					}).catch(function() {
						that.statusForm.pay_status = prev
						that.receivedEditing = !1
					})
					return
				}
				that.confirmStatusChange('确定将付款状态改为「未付款」吗？实收款、说明与附件将清空。', function() {
					that.statusForm.pay_status = prev
				})
			},
			saveForm(purchaseForm) {
				let that = this
				if (that.purchaseStatus) return
				that.$refs[purchaseForm].validate((valid) => {
					if (valid) {
						console.log(that.purchaseForm)
						that.purchaseStatus = !0
						that.$fetch('addons/hlm/api.Order/addPurchase', that.purchaseForm).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								that.purchaseStatus = !1,that.$message({
									message: '保存成功',
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										
									}
								}),that.getDetail()
							}else{
								that.purchaseStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.purchaseStatus = !1
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			printQuotation() {
				let that = this
				that.$router.push(`/print?id=${that.offer_id}&status=1`)
			},
			openCollOrder() {
				const that = this
				if (!that.detail || !that.canOpenColl || that.collLoading) return
				that.collLoading = !0
				that.$fetch('addons/hlm/api.Order/getOrderToken', {
					order_number: that.detail.order_number,
					base_url: window.location.origin,
				}).then(function(res) {
					if (res.code == 1) {
						that.collUrl = res.data.url || ''
						that.collDate = Number(res.data.vaild_time || 0) * 1000
						that.collStatus = !0
					}
				}).catch(function(error) {
					console.log(error)
				}).finally(function() {
					that.collLoading = !1
				})
			},
			setCollDate(e) {
				const that = this
				if (!that.detail) return
				that.$fetch('addons/hlm/api.Order/upTime', {
					order_number: that.detail.order_number,
					time: Math.floor(Number(e) / 1000),
				}).then(function(res) {
					if (res.code == 1) {
						that.$message({ message: '有效时间已更新', type: 'success', duration: 1500, center: !0 })
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			copyColl() {
				const that = this
				const text = that.collUrl || ''
				if (!text) {
					that.$message({ message: '暂无协同链接', type: 'warning', duration: 1500, center: !0 })
					return
				}
				const onOk = function() {
					that.$message({ message: '复制成功', type: 'success', duration: 1500, center: !0 })
				}
				const onFail = function() {
					that.$message({ message: '复制失败，请手动复制', type: 'warning', duration: 1500, center: !0 })
				}
				if (that.$copyText) {
					that.$copyText(text).then(onOk, onFail)
					return
				}
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(text).then(onOk).catch(onFail)
					return
				}
				try {
					const input = document.createElement('input')
					input.value = text
					document.body.appendChild(input)
					input.select()
					document.execCommand('copy')
					document.body.removeChild(input)
					onOk()
				} catch (e) {
					onFail()
				}
			},
			addColl() {
				const that = this
				if (!that.detail) return
				const nowTime = Number(that.collDate) + 24 * 3600000
				that.$fetch('addons/hlm/api.Order/upTime', {
					order_number: that.detail.order_number,
					time: Math.floor(nowTime / 1000),
				}).then(function(res) {
					if (res.code == 1) {
						that.collDate = nowTime
						that.$message({ message: '已延长一天', type: 'success', duration: 1500, center: !0 })
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			closeColl() {
				const that = this
				if (!that.detail) return
				that.$confirm('关闭后协同链接将立即失效，是否继续？', '关闭协同', {
					confirmButtonText: '关闭',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(function() {
					const nowTime = Date.now()
					that.$fetch('addons/hlm/api.Order/upTime', {
						order_number: that.detail.order_number,
						time: Math.floor(nowTime / 1000),
					}).then(function(res) {
						if (res.code == 1) {
							that.collDate = nowTime
							that.collUrl = ''
							that.collStatus = !1
							that.$message({ message: '已关闭协同订单', type: 'success', duration: 1500, center: !0 })
						}
					}).catch(function(error) {
						console.log(error)
					})
				}).catch(function() {})
			},
			editOffer(e){
				let that = this
				that.$router.push(`/offerEdit?id=${that.offer_id}`)
			},
			printInvoice() {
				let that = this
			},
			goBack(){
				this.$router.back()
			},
			// 参考图
			showReference(row){
				let that = this;
				console.log(row)
				if(row.reference_image&&row.reference_image!=="") that.reference = row,that.referenceStatus = !0;
			}
		}
	};
</script>

<style src='../assets/css/offerDetail.css'>
	/* px2rem能正常转换 */
</style>
<style src='../assets/css/offer-detail-mobile.css'></style>



// WEBPACK FOOTER //
// src/pages/offerDetail.vue